export type TFolderMenu = {
    title: string;
    url: string;
};
export type TSubMenu = {
    title: string;
    url: string;
    icon: string;
    folderMenus?: Array<TFolderMenu>;
};

export type TMenuList = Array<{ title: string; url: string; subMenus: Array<TSubMenu> }>;

export const menusList: TMenuList = [
    {
        title: "order",
        url: "/content",
        subMenus: [
            {
                title: "menu.content.stock",
                url: "/content/stock",
                icon: "/media/icons/duotune/files/fil012.svg",
            },
            {
                title: "menu.content.towrite",
                url: "/content/toWrite",
                icon: "/media/icons/duotune/art/art005.svg",
            },
            {
                title: "menu.content.delivered",
                url: "/content/delivered",
                icon: "/media/icons/duotune/files/fil008.svg",
            },
            {
                title: "menu.content.toproofread",
                url: "/content/toProofread",
                icon: "/media/icons/duotune/general/gen004.svg",
            },
            {
                title: "menu.content.reviewed",
                url: "/content/reviewed",
                icon: "/media/icons/duotune/files/fil008.svg",
            },
            {
                title: "menu.content.toprocess",
                url: "/content/toProcess",
                icon: "/media/icons/duotune/general/gen062.svg",
            },
            {
                title: "menu.content.toapprove",
                url: "/content/toApprove",
                icon: "/media/icons/duotune/general/gen063.svg",
            },
            {
                title: "menu.content.topublish",
                url: "/content/toPublish",
                icon: "/media/icons/duotune/general/gen016.svg",
            },
            {
                title: "menu.content.waiting",
                url: "/content/waiting",
                icon: "/media/icons/duotune/general/gen012.svg",
            },
            {
                title: "menu.content.online",
                url: "/content/online",
                icon: "/media/icons/duotune/abstract/abs036.svg",
            },
        ],
    },
    {
        title: "analyse",
        url: "/analyse",
        subMenus: [
            {
                title: "menu.analyse.sites",
                url: "/analyse/global/monitoring",
                icon: "/media/icons/duotune/general/gen021.svg",
            },
            {
                title: "menu.analyse.site",
                url: "/analyse/zoom",
                icon: "/media/icons/duotune/graphs/gra004.svg",
            },
            {
                title: "menu.analyzed.urls",
                url: "/analyse/urls",
                icon: "/media/icons/duotune/coding/cod007.svg",
            },
            {
                title: "menu.analyse.boost",
                url: "/analyse/boost",
                icon: "/media/icons/duotune/general/gen002.svg",
            },
        ],
    },

    {
        title: "Resource",
        url: "/resource",
        subMenus: [
            {
                title: "menu.title.sites",
                url: "/sites",
                icon: "/media/icons/duotune/communication/com001.svg",
            },
            {
                title: "menu.title.platform",
                url: "/platforms",
                icon: "/media/icons/duotune/finance/fin009.svg",
            },
            {
                title: "menu.title.messageCenter",
                url: "/message-center",
                icon: "/media/icons/duotune/technology/teh007.svg",
            },
            {
                title: "menu.title.directory",
                url: "/directory",
                icon: "/media/icons/duotune/technology/teh001.svg",
            },
        ],
    },

    {
        title: "reporting",
        url: "/reports",
        subMenus: [
            {
                title: "menu.title.reporting",
                url: "/reports",
                icon: "/media/icons/duotune/abstract/abs015.svg",
                folderMenus: [
                    {
                        title: "menu.monitoring.writers",
                        url: "/reports/writers",
                    },
                    {
                        title: "menu.monitoring.proofreaders",
                        url: "/reports/proofreaders",
                    },
                ],
            },
            {
                title: "menu.title.budget",
                url: "/budgets",
                icon: "/media/icons/duotune/finance/fin003.svg",
            },
        ],
    },
];
